/**
 * Logging utility that suppresses verbose logs in production
 */

const isDev = import.meta.env.DEV;

export const logger = {
  log: (...args: unknown[]) => isDev && console.log('[App]', ...args),
  info: (...args: unknown[]) => isDev && console.info('[Info]', ...args),
  warn: (...args: unknown[]) => console.warn('[Warn]', ...args),
  error: (...args: unknown[]) => console.error('[Error]', ...args),
  debug: (...args: unknown[]) => isDev && console.debug('[Debug]', ...args),
  
  // Named loggers for specific modules
  cloud: (...args: unknown[]) => isDev && console.log('[Cloud]', ...args),
  auth: (...args: unknown[]) => isDev && console.log('[Auth]', ...args),
  store: (...args: unknown[]) => isDev && console.log('[Store]', ...args),
  notes: (...args: unknown[]) => isDev && console.log('[Notes]', ...args),
  sync: (...args: unknown[]) => isDev && console.log('[Sync]', ...args),
  files: (...args: unknown[]) => isDev && console.log('[Files]', ...args),
  video: (...args: unknown[]) => isDev && console.log('[Video]', ...args),
  pwa: (...args: unknown[]) => isDev && console.log('[PWA]', ...args),
  blocking: (...args: unknown[]) => isDev && console.log('[Blocking]', ...args),
};












